import styled from 'styled-components'

export const Label = styled.label`
  display: block;
  line-height: 31px;
  font-family: Nunito;
  font-size: 20px;
  font-weight: 800;
  color: #172129;
  margin-bottom: 12px;
`



// WEBPACK FOOTER //
// ./src/atoms/Label.tsx